import axios from "axios";
import { BACKEND_URL } from "../constants";

export const get_notices = async ({ user, company, includeInactive = false }) => {
  const { data } = await axios.post(
    `${BACKEND_URL}/notices/list`,
    { userId: user._id, companyId: company._id, includeInactive },
    { withCredentials: true }
  );
  return data;
};

export const create_notice = async ({ user, company, notice, notify = true }) => {
  const { data } = await axios.post(
    `${BACKEND_URL}/notices/create`,
    { userId: user._id, companyId: company._id, notice, notify },
    { withCredentials: true }
  );
  return data;
};

export const update_notice = async ({ user, company, noticeId, notice }) => {
  const { data } = await axios.post(
    `${BACKEND_URL}/notices/update`,
    { userId: user._id, companyId: company._id, noticeId, notice },
    { withCredentials: true }
  );
  return data;
};

export const archive_notice = async ({ user, company, noticeId }) => {
  const { data } = await axios.post(
    `${BACKEND_URL}/notices/archive`,
    { userId: user._id, companyId: company._id, noticeId },
    { withCredentials: true }
  );
  return data;
};
